import { render } from "./OcDetalle.vue?vue&type=template&id=42fe2842"
import script from "./OcDetalle.vue?vue&type=script&lang=js"
export * from "./OcDetalle.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__